module.exports = __webpack_public_path__ + "img/access_restriction.5c07cdb6.png";